module.exports = __webpack_public_path__ + "img/1725845381984-screenshot-1725845363671.png.28aa3a71.webp";